import { defineFakeRoute } from 'vite-plugin-fake-server/client';

const rolesInfo = [
  {
    roleId: '1000028467',
    roleCode: 'portal-config-root',
    roleName: '管理员',
    isDefaultRole: '0',
    moduleId: null,
    moduleCode: null,
    moduleName: null,
    moduleIcon: null,
    moduleType: null,
    parentId: null,
    sort: null,
    subsysCode: 'acsp-portal-config-manager',
    hidden: null,
    helpUrl: null,
    checkStatus: null,
    childModules: [],
  },
  {
    roleId: '1000029828',
    roleCode: 'buacAdmin',
    roleName: 'B端后台配置管理员',
    isDefaultRole: '1',
    moduleId: null,
    moduleCode: null,
    moduleName: null,
    moduleIcon: null,
    moduleType: null,
    parentId: null,
    sort: null,
    subsysCode: 'acsp-portal-config-manager',
    hidden: null,
    helpUrl: null,
    checkStatus: null,
    childModules: [],
  },
  {
    roleId: '1000030502',
    roleCode: 'buacAccountUnlock',
    roleName: 'B端账号解锁角色',
    isDefaultRole: '0',
    moduleId: null,
    moduleCode: null,
    moduleName: null,
    moduleIcon: null,
    moduleType: null,
    parentId: null,
    sort: null,
    subsysCode: 'acsp-portal-config-manager',
    hidden: null,
    helpUrl: null,
    checkStatus: null,
    childModules: [],
  },
  {
    roleId: '1000031714',
    roleCode: 'by-admin',
    roleName: '百源后台管理员',
    isDefaultRole: '0',
    moduleId: null,
    moduleCode: null,
    moduleName: null,
    moduleIcon: null,
    moduleType: null,
    parentId: null,
    sort: null,
    subsysCode: 'bx-admin',
    hidden: null,
    helpUrl: null,
    checkStatus: null,
    childModules: [],
  },
  {
    roleId: '1000031743',
    roleCode: 'bx_manage_operator',
    roleName: '企服运营',
    isDefaultRole: '0',
    moduleId: null,
    moduleCode: null,
    moduleName: null,
    moduleIcon: null,
    moduleType: null,
    parentId: null,
    sort: null,
    subsysCode: 'bx-manage',
    hidden: null,
    helpUrl: null,
    checkStatus: null,
    childModules: [],
  },
  {
    roleId: '1000031744',
    roleCode: 'bx_manage_development',
    roleName: '企服研发',
    isDefaultRole: '0',
    moduleId: null,
    moduleCode: null,
    moduleName: null,
    moduleIcon: null,
    moduleType: null,
    parentId: null,
    sort: null,
    subsysCode: 'bx-manage',
    hidden: null,
    helpUrl: null,
    checkStatus: null,
    childModules: [],
  },
  {
    roleId: '1000031745',
    roleCode: 'bx_manage_reviewer',
    roleName: '企服审核',
    isDefaultRole: '0',
    moduleId: null,
    moduleCode: null,
    moduleName: null,
    moduleIcon: null,
    moduleType: null,
    parentId: null,
    sort: null,
    subsysCode: 'bx-manage',
    hidden: null,
    helpUrl: null,
    checkStatus: null,
    childModules: [],
  },
  {
    roleId: '1000031746',
    roleCode: 'bx_manage_admin',
    roleName: 'BX管理员',
    isDefaultRole: '0',
    moduleId: null,
    moduleCode: null,
    moduleName: null,
    moduleIcon: null,
    moduleType: null,
    parentId: null,
    sort: null,
    subsysCode: 'bx-manage',
    hidden: null,
    helpUrl: null,
    checkStatus: null,
    childModules: [],
  },
];
export default defineFakeRoute([
  {
    url: '/o-apis-example/mock/dev-basp-user/indexModule/queryRoles',
    timeout: 10,
    method: 'get',
    response: () => {
      return {
        succ: 'ok',
        msg: null,
        result: rolesInfo,
      };
    },
  },
]);
